import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { WhiteSpace } from 'antd-mobile'
import { Form, Input, List } from 'antd-mobile-v5'
import { FormattedMessage, useIntl } from 'react-intl'
import ApplicationStatus from './ApplicationStatus.js'
import { formatDate, languagesMapping, removeExpires } from '../../components/common/utils'
import DiverInfo from '../../components/FormTools/DiverInfo'
import Header from '../../components/FormTools/FormHeader'
import UploadOssFile from '../../components/FormTools/UploadOssFile'
import Signature from '../../components/FormTools/Signature'
import SearchInstructor from '../../components/FormTools/SearchInstructor'
import SearchStoreInfo from '../../components/FormTools/SearchStoreInfo'
import DatePickerTool from '../../components/FormTools/DatePicker'
import PickerTool from '../../components/FormTools/Picker'
import dayjs from 'dayjs'

const Item = List.Item

const EFRITDetail = () => {
  const [form] = Form.useForm()
  const { formatMessage } = useIntl()
  const [signature, setSignature] = useState('')
  const [instructorVerify, setInstructorVerify] = useState(false)
  const [storeVerify, setStoreVerify] = useState(false)
  const { detail, ossSignature } = useSelector((state) => ({
    detail: state.efri.efrtDetail,
    ossSignature: state.oss.ossSignature,
  }))

  const editable = !!(detail.status === 'WAIT_CONFIRM' || detail.status === 'ADMIN_NOT_APPROVED')
  const filename = () => `${ossSignature.dir}${new Date().getTime()}`

  useEffect(() => {
    form.setFieldsValue({
      efri: detail.efri,
      efrfiles: detail.efrfiles || [],
      courseDate: detail.courseDate ? new Date(detail.courseDate) : undefined,
      instructorNumber: detail.instructorInfoDTO ? detail.instructorInfoDTO.instructorNumber : '',
      storeNumber: detail.storeInfoDTO ? detail.storeInfoDTO.storeNumber : '',
      languageId: detail.languageId || '',
      regionId: detail.regionDTO ? detail.regionDTO.region : '',
    })
    setSignature(detail.handwrittenSignatureUrlEFRT)
  }, [detail])

  const getSubmitData = () => {
    const values = form.getFieldsValue(true)
    const { storeNumber, regionId, courseDate, efrfiles, ...data } = values
    let newData = {
      ...data,
      courseDate: formatDate(courseDate, 'YYYY-MM-DD'),
      efrfiles: removeExpires(efrfiles),
    }
    if (storeVerify) newData.storeNumber = storeNumber
    return newData
  }

  if (!Object.keys(detail).length > 0) return null
  return (
    <>
      <Header text={<FormattedMessage id="efri-application" />} code={detail?.code} />
      <DiverInfo info={detail.userInfoDTO} />
      <Form form={form} validateTrigger="onSubmit">
        <Form.Header>先决条件</Form.Header>
        {detail.efr ? (
          <Item>{`EFR (${detail.efr})`}</Item>
        ) : (
          <Form.Item
            name="efrfiles"
            label={'EFR'}
            form={form}
            rules={[
              {
                required: true,
                message: formatMessage({ id: 'form-upload-error' }),
              },
            ]}
          >
            <UploadOssFile
              form={form}
              fileName={filename()}
              ossSignature={ossSignature}
              onSuccess={(file) => form.setFieldsValue({ efrfiles: file })}
              editable={editable}
              fileList={form.getFieldValue('efrfiles')}
              tips={<FormattedMessage id="common-upload-file-reminder" />}
            />
          </Form.Item>
        )}
        <Form.Header>训练信息</Form.Header>
        {(editable || (!editable && detail.instructorInfoDTO)) && (
          <SearchInstructor
            idType={'trainer'}
            type={'NONE'}
            form={form}
            editable={editable}
            instructorVerify={instructorVerify}
            setInstructorVerify={setInstructorVerify}
            required={true}
            initInstructorInfo={detail.instructorInfoDTO}
          />
        )}
        {(editable || (!editable && detail.storeInfoDTO)) && (
          <SearchStoreInfo
            form={form}
            setStoreVerify={setStoreVerify}
            storeVerify={storeVerify}
            editable={editable}
            initStoreInfo={detail.storeInfoDTO}
          />
        )}
        <DatePickerTool
          name="courseDate"
          placeholder={formatMessage({ id: 'efri-course-date-error' })}
          disabled={!editable}
          label={formatMessage({ id: 'common-course-date' })}
          rules={[
            {
              required: true,
              message: formatMessage({ id: 'efri-course-date-error' }),
            },
          ]}
          max={dayjs().toDate()}
          form={form}
        />
        <Form.Header>教学地址及语言</Form.Header>
        <Form.Item name="regionId" label={formatMessage({ id: 'dm-region' })} disabled={true}>
          <Input />
        </Form.Item>
        <PickerTool
          name={'languageId'}
          form={form}
          rules={[
            {
              required: true,
              message: '语言不能为空',
            },
          ]}
          placeholder={formatMessage({ id: 'dm-lang-error' })}
          data={languagesMapping}
          label={formatMessage({ id: 'dm-lang-title' })}
          disabled={!editable}
        />
      </Form>
      <WhiteSpace />
      <Signature
        title={formatMessage({ id: 'dm-form-signature' })}
        filePath={`signature/${detail.instructorInfoDTO.affiliateId}`}
        modified={editable}
        oss={ossSignature}
        onSuccess={(imgUrl) => setSignature(imgUrl)}
        onClear={() => setSignature('')}
        initSignature={signature}
      />
      <WhiteSpace />
      <ApplicationStatus form={form} detail={detail} getSubmitData={getSubmitData} signature={signature} />
      <WhiteSpace size="lg" />
    </>
  )
}

export default EFRITDetail
